import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

type ButtonColors = 'none' | 'primary' | 'secondary' | 'tertiary' | 'success' | 'danger' | 'light' | 'medium' | 'dark';

interface BasicButtonProps {
	color?: ButtonColors;
	bordered?: boolean;
	filled?: boolean; // whether the background is filled or not
	blocked?: boolean;
	uppercase?: boolean;
	disabled?: boolean;
	rounded?: boolean;
	size?: 'small' | 'default' | 'large' | 'none';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicButton',
  props: {
    color: { default: 'secondary' },
    bordered: { type: Boolean },
    filled: { type: Boolean, default: true },
    blocked: { type: Boolean },
    uppercase: { type: Boolean },
    disabled: { type: Boolean },
    rounded: { type: Boolean, default: true },
    size: { default: 'default' }
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props as { color: ButtonColors, bordered?: boolean, filled: boolean, blocked?: boolean, uppercase?: boolean, disabled?: boolean, rounded: boolean, size: 'small' | 'default' | 'large' | 'none' };





const classes = computed(() => {
	return {
		// colors
		primary: props.color === 'primary',
		secondary: props.color === 'secondary',
		tertiary: props.color === 'tertiary' || props.color === 'dark',
		light: props.color === 'light',
		medium: props.color === 'medium',

		// size
		sm: props.size === 'small',
		md: props.size === 'default',
		lg: props.size === 'large',

		border: props.bordered,
		'w-full': props.blocked,
		'bg-none': !props.filled,
		uppercase: props.uppercase,
		rounded: props.rounded,
		disabled: props.disabled,
	};
});

return { __sfc: true,props, classes }
}

})